/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Link_FailedInputs */

const en_portalsignin_link_failed = /** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link could not be sent. Check the address, then try again in a minute.`)
};

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const ar_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const he_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const ur_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const es_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const fr_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const de_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const pt_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const hi_portalsignin_link_failed = en_portalsignin_link_failed;

/** @type {(inputs: Portalsignin_Link_FailedInputs) => LocalizedString} */
const bn_portalsignin_link_failed = en_portalsignin_link_failed;

/**
* | output |
* | --- |
* | "The link could not be sent. Check the address, then try again in a minute." |
*
* @param {Portalsignin_Link_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_link_failed = /** @type {((inputs?: Portalsignin_Link_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Link_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_link_failed(inputs)
	if (locale === "he") return he_portalsignin_link_failed(inputs)
	if (locale === "ur") return ur_portalsignin_link_failed(inputs)
	if (locale === "es") return es_portalsignin_link_failed(inputs)
	if (locale === "fr") return fr_portalsignin_link_failed(inputs)
	if (locale === "de") return de_portalsignin_link_failed(inputs)
	if (locale === "pt") return pt_portalsignin_link_failed(inputs)
	if (locale === "hi") return hi_portalsignin_link_failed(inputs)
	if (locale === "bn") return bn_portalsignin_link_failed(inputs)
	return /** @type {LocalizedString} */ ("The link could not be sent. Check the address, then try again in a minute.")
});